function initSideMenuComponents(app) {
    app.component('side-menu', {
        template: '#side-menu-template',
    });

    app.component('side-menu-item', {
        template: '#side-menu-item-template',
        props: {
            isActive: {},
        },
        methods: {
            select() {
                this.$emit('selected');
            },
        },
    });
}

export default initSideMenuComponents;
